<template >
  <Layout>
    <b-row class="row-padding text-center">
      <b-col>
        <h1 class="title">Configurações</h1>
      </b-col>
    </b-row>
    <Form>
      <Tabs :menus="panelMenus">
        <template v-slot:0>
          <General />
        </template>
        <template v-slot:1>
          <WebService v-if="dataLoaded" />
        </template>
        <template v-slot:2>
          <Series v-if="dataLoaded" />
        </template>
        <template v-slot:3>
          <Tributes v-if="dataLoaded" />
        </template>
      </Tabs>
      <FooterForm :hasCancel="false" @submit="save" />
    </Form>
  </Layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Layout, Tabs } from '@/components';
import { Form, FooterForm } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import General from './components/General';
import WebService from './components/WebService';
import Series from './components/Series';
import Tributes from './components/Tributes';

export default {
  name: 'InventoryServiceList',
  mixins: [FormatMixin],
  components: {
    Layout,
    Form,
    FooterForm,
    General,
    Tabs,
    WebService,
    Series,
    Tributes,
  },
  data() {
    return {
      dataLoaded: false,
      panelMenus: [
        { id: 0, label: 'Geral' },
        { id: 1, label: 'WebService' },
        { id: 2, label: 'Série/Número' },
        { id: 3, label: 'Tributos' },
      ],
    };
  },
  async mounted() {
    this.setLoading(true);
    await this.setConfiguration();
    this.dataLoaded = true;
    this.setLoading(false);
  },
  computed: {
    ...mapState('nfseConfigurations', ['nfseConfigurations']),
  },
  methods: {
    ...mapActions('nfseConfigurations', [
      'setConfiguration',
      'updateConfiguration',
    ]),
    ...mapActions('application', ['setLoading']),

    async save() {
      try {
        this.setLoading(true);
        const {
          pisPercentage,
          cofinsPercentage,
          inssPercentage,
          csllPercentage,
          irPercentage,
        } = this.nfseConfigurations;

        const payload = {
          ...this.nfseConfigurations,
          pisPercentage: this.valorUS(pisPercentage),
          cofinsPercentage: this.valorUS(cofinsPercentage),
          inssPercentage: this.valorUS(inssPercentage),
          csllPercentage: this.valorUS(csllPercentage),
          irPercentage: this.valorUS(irPercentage),
        };
        await this.updateConfiguration(payload);
        this.$alert.success('Configurações salvas com sucesso.');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
